module.exports = __webpack_public_path__ + "media/tropic_of_capricorn.f4275f66.geojson";


//////////////////
// WEBPACK FOOTER
// ./src/resources/vector/grid/tropic_of_capricorn.geojson
// module id = 1120
// module chunks = 0